const PrivacyPolicy = () => {
  return <>PRIVACY POLICY</>;
};

export default PrivacyPolicy;
